import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import Layout from "../components/layout";
// import DashboardScreen from "./dashboard/index";
import Salir from "./salir";
import RouterConfiguracion from "./configuracion/router";
import RouterChecklist from "./checklist/router";
import RouterUsuario from "./usuario/router";
import RouterAlertasChecklist from "./alertas/router";
import RouterDashboard from "./dashboard/router";
import RouterReportes from "./reportes/router";
import RouterAdministracion from "./administracion/router";

const RouterPage = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Layout>
        <Route path={`${path}alertas`}>
          <RouterAlertasChecklist />
        </Route>
        <Route path={`${path}checklist`}>
          <RouterChecklist />
        </Route>
        <Route path={`${path}configuracion`}>
          <RouterConfiguracion />
        </Route>
        <Route path={`${path}usuario`}>
          <RouterUsuario />
        </Route>
        <Route path={`${path}salir`}>
          <Salir />
        </Route>
        <Route path={`${path}dashboard`}>
          <RouterDashboard />
        </Route>
        <Route path={`${path}reportes`}>
          <RouterReportes />
        </Route>
        <Route path={`${path}administracion`}>
          <RouterAdministracion />
        </Route>


        <Route exact path={`${path}`}>
          <RouterDashboard />
        </Route>
      </Layout>
    </Switch>
  );
};

export default RouterPage;
